import { render, staticRenderFns } from "./TemplateColumnButtonSettings.vue?vue&type=template&id=7e53537a&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./TemplateColumnButtonSettings.vue?vue&type=script&lang=js&"
export * from "./TemplateColumnButtonSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e53537a')) {
      api.createRecord('7e53537a', component.options)
    } else {
      api.reload('7e53537a', component.options)
    }
    module.hot.accept("./TemplateColumnButtonSettings.vue?vue&type=template&id=7e53537a&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&", function () {
      api.rerender('7e53537a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/Settings/TemplateColumnButtonSettings.vue"
export default component.exports